import { lazy } from 'react';
import PageView from './PageView';

const CancellationSchedulePage = lazy(() => import('src/pages/cancellationSchedule'));

export const cancellationScheduleRoutes = [
  {
    path: 'cancellation-schedule',
    element: <PageView permission="BO_CAN_VIEW_CANCELATION_SCHEDULE" />,
    children: [{ element: <CancellationSchedulePage />, index: true }],
  },
];
